import type { ReactNode } from 'react';
import { Typography, theme } from 'antd';
import type { ItemErrorGroup } from '@/components/user_catalog/modStatusBulk';

const { Text } = Typography;

interface ModStatusRefusalGroupsProps {
  groups: ItemErrorGroup[];
  /** Line above the reasons, e.g. what was changed and what was not. */
  summary?: ReactNode;
  /** Scroll the reasons past this height — a batch can refuse 50 objects. */
  maxHeight?: number;
}

/** Moderation refusals: each reason, how many it hit, and their names. */
export const ModStatusRefusalGroups = ({
  groups,
  summary,
  maxHeight,
}: ModStatusRefusalGroupsProps) => {
  const { token } = theme.useToken();
  return (
    <div>
      {summary != null && (
        <Text type="secondary" style={{ display: 'block' }}>
          {summary}
        </Text>
      )}
      <div style={maxHeight ? { maxHeight, overflowY: 'auto' } : undefined}>
        {groups.map((g) => (
          <div key={g.message} style={{ marginTop: token.marginXS }}>
            <Text type="danger">
              {g.message} ({g.items.length})
            </Text>
            <ul
              style={{
                margin: 0,
                paddingInlineStart: token.paddingLG,
                color: token.colorTextSecondary,
              }}
            >
              {g.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
